import { withMultiButtonSelectHOC } from "shared/HOC";

const DEFAULT_ATTRIBUTES = [
  { value: 'Bright Colors', label: 'Bright Colors' },
  { value: 'Dark Colors', label: 'Dark Colors' },
  { value: 'Edgy Details', label: 'Edgy Details' },
  { value: 'Light Colors', label: 'Light Colors' },
  { value: 'Minimal Tones', label: 'Minimal Tones' },
  { value: 'Prints', label: 'Prints' }
];

const AttributeSelectButtons = withMultiButtonSelectHOC(DEFAULT_ATTRIBUTES);
export default AttributeSelectButtons;
